import { styled, alpha } from '@mui/material/styles';
import { ListItemText, ListItemButton, ListItemIcon } from '@mui/material';
// next
import NextLink from 'next/link';
import { useRouter } from 'next/router';
// components
import Avatar from '../../../components/Avatar';
// config
import { NAVBAR } from '../../../config';
import { getActiveCrew } from '..';

export const ListItemStyle = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'activeRoot' && prop !== 'activeSub' && prop !== 'subItem',
})(({ activeRoot, activeSub, subItem, theme }) => ({
  ...theme.typography.caption,
  position: 'relative',
  height: NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(0.5),
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius,
  // activeRoot
  ...(activeRoot && {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.grey[200],
  }),
  // activeSub
  ...(activeSub && {
    color: theme.palette.text.primary,
  }),
  // subItem
  ...(subItem && {
    height: NAVBAR.DASHBOARD_ITEM_SUB_HEIGHT,
  }),
}));

export const ListItemTextStyle = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== 'isCollapse',
})(({ isCollapse, theme }) => ({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  transition: theme.transitions.create(['width', 'opacity'], {
    duration: theme.transitions.duration.shorter,
  }),
  ...(isCollapse && {
    width: 0,
    opacity: 0,
  }),
}));

export const ListItemIconStyle = styled(ListItemIcon)({
  width: 24,
  height: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': { width: '100%', height: '100%' },
});


export function CrewItem({crew}) {
  const { id, randomhash, nickname, path } = crew;
  
  const { asPath } = useRouter();

  const active = getActiveCrew(id, asPath);

  const renderContent = (
    <>
      <ListItemIconStyle>
        <Avatar
          src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/crewji/crewji_${randomhash || '5'}.png`}
          alt={nickname}
          color={'default'}
          sx={{
            margin: 'auto',
            width: 24,
            height: 24,
          }}
        />
      </ListItemIconStyle>
      <ListItemTextStyle
        disableTypography
        primary={<b>{nickname}</b>}
        secondary={' 크루'}
      />
    </>
  );

  // path 를 만들어야 겠군

  return (
    <NextLink href={path} passHref>
      <ListItemStyle activeRoot={active}>{renderContent}</ListItemStyle>
    </NextLink>
  )
}